import PageHeader, { PageHeaderProps } from '../CommonComponents/Header';

interface PageHeaderWrapperProps extends PageHeaderProps {
  children: React.ReactNode;
  contentClassName?: string;
}

const PageHeaderWrapper: React.FC<PageHeaderWrapperProps> = ({
  children,
  contentClassName = 'px-6 py-5 space-y-4',
  ...headerProps
}) => {
  return (
    <div>
      <PageHeader {...headerProps} />

      <div className={contentClassName}>{children}</div>
    </div>
  );
};

export default PageHeaderWrapper;
